import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55c89f1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row-span-1 text-sm sm:text-base lg:text-sm xl:text-base" }
const _hoisted_2 = { class: "font-bold text-xl sm:text-4xl lg:text-xl xl:text-4xl" }
const _hoisted_3 = { class: "py-4 sm:py-10 lg:py-4 xl:py-10" }
const _hoisted_4 = { class: "row-span-2 p-6 max-w-sm h-fit bg-white rounded-lg border border-gray-200 shadow-md dark:bg-gray-800 dark:border-gray-700" }
const _hoisted_5 = { class: "flex justify-between font-bold mb-3" }
const _hoisted_6 = { class: "text-sm leading-8" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "text-sm font-medium mt-3 text-black" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "text-sm font-bold mt-3" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "audio-bar" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "audio-level" }),
  /*#__PURE__*/_createElementVNode("div", { class: "background" })
], -1))
const _hoisted_15 = { class: "row-span-1 text-sm sm:text-base lg:text-sm xl:text-base" }
const _hoisted_16 = { class: "py-6 xl:py-10 font-bold" }

import DiagnosticSection from '@/components/video-diagnostic/DiagnosticSection.vue'
import { useAudioTest } from '@/composables/video-diagnostic/useAudioTest'
import { useDevices } from '@/composables/video-diagnostic/useDevices'
import { Stage } from '@/types/enums/video-diagnostic.enum'
import { watch, computed } from 'vue'

interface AudioTestEmits {
  (e: 'nextStage', value: number): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AudioTest',
  props: {
  stage: {
    type: Number,
    required: true,
  },
},
  emits: ["nextStage"],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "551d34a9": (audioLevelCss.value)
}))

const props = __props

const emit = __emit

const { audioInputDevices, audioOutputDevices } = useDevices()
const {
  countPlay,
  readAudioInput,
  playAudio,
  clearAudioDeviceTest,
  setAudioTestResult,
  isAudioOutputTestRunning,
  isAudioInputTestRunning,
  outputLevel,
  inputLevel,
  isRecording,
  enableRecording,
  selectedAudio,
  selectedSpeaker,
  playbackURI,
  timeCounter,
} = useAudioTest()

let stopWatchIsAudioInputTestRunning

const volumeLevel = computed(() =>
  isAudioOutputTestRunning.value ? outputLevel.value : inputLevel.value,
)
const audioLevelCss = computed(() => Math.max(0, 100 - volumeLevel.value))
const disableAll = computed(() => isRecording.value || isAudioOutputTestRunning.value)
const noAudioRedirect = !Audio.prototype.setSinkId

watch(
  () => props.stage,
  async (stage, prevStage) => {
    if (prevStage === Stage.AUDIO_TEST) {
      if (stopWatchIsAudioInputTestRunning) {
        stopWatchIsAudioInputTestRunning()
      }
      clearAudioDeviceTest()
    }
    if (stage === Stage.AUDIO_TEST) {
      readAudioInput()
      stopWatchIsAudioInputTestRunning = watch(
        () => isAudioInputTestRunning.value,
        (value, prevValue) => {
          if (prevValue === true && value === false) {
            enableRecording.value = false
            readAudioInput()
          }
        },
      )
    }
    if (stage === Stage.RESULTS) {
      readAudioInput()
      watch(
        () => isAudioInputTestRunning.value,
        (value, prevValue) => {
          if (prevValue === true && value === false) {
            enableRecording.value = false
            readAudioInput()
          }
        },
      )
    }
  },
)

watch(
  () => audioInputDevices.value,
  () => {
    initSelectedAudioAndSpeaker()
  },
  { deep: true },
)

const handleRecordClick = () => {
  enableRecording.value = true
  readAudioInput()
}

const nextStage = (testResult: boolean) => {
  setAudioTestResult(testResult)
  emit('nextStage', Stage.BROWSER_TEST)
}

const initSelectedAudioAndSpeaker = () => {
  if (!selectedAudio.value) {
    selectedAudio.value = audioInputDevices.value[0].value
  }
  if (!selectedSpeaker.value) {
    selectedSpeaker.value = audioOutputDevices.value[0].value
  }
}

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_SelectOption = _resolveComponent("SelectOption")!

  return (_openBlock(), _createBlock(DiagnosticSection, {
    id: _unref(Stage).AUDIO_TEST,
    class: _normalizeClass(
      __props.stage === _unref(Stage).AUDIO_TEST || __props.stage === _unref(Stage).RESULTS
        ? 'block'
        : 'hidden md:block opacity-30 pointer-events-none'
    )
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('video-diagnostic.audio-test')), 1),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('video-diagnostic.audio-test-detail')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('video-diagnostic.audio')), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: _normalizeClass(["audio-record-btn mr-2", [!_unref(playbackURI) && 'active', _unref(isRecording) && 'recording']]),
              type: "button",
              disabled: disableAll.value,
              onClick: handleRecordClick
            }, [
              (_unref(isRecording))
                ? (_openBlock(), _createBlock(_component_SvgIcon, {
                    key: 0,
                    class: "mr-2",
                    icon: 'record',
                    "inherit-fill": true,
                    height: "16"
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(_unref(isRecording)
                  ? _ctx.$tc('video-diagnostic.n-second', _unref(timeCounter))
                  : _ctx.$t('video-diagnostic.record')), 1)
            ], 10, _hoisted_8),
            _createElementVNode("button", {
              class: _normalizeClass(["audio-record-btn", [!!_unref(playbackURI) && 'active']]),
              type: "button",
              disabled: !_unref(playbackURI) || disableAll.value,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(playAudio) && _unref(playAudio)(...args)))
            }, [
              (_unref(isAudioOutputTestRunning))
                ? (_openBlock(), _createBlock(_component_SvgIcon, {
                    key: 0,
                    class: "mr-2",
                    icon: 'speaker',
                    "inherit-fill": true,
                    height: "16"
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("span", null, _toDisplayString(_unref(isAudioOutputTestRunning)
                    ? _ctx.$t('video-diagnostic.audio-playing')
                    : _ctx.$tc('video-diagnostic.play-back', _unref(countPlay))), 1)
            ], 10, _hoisted_9)
          ])
        ]),
        _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('video-diagnostic.speaker')), 1),
        noAudioRedirect
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, "System Default Audio Output"))
          : (_openBlock(), _createBlock(_component_SelectOption, {
              key: 1,
              modelValue: _unref(selectedSpeaker),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selectedSpeaker) ? (selectedSpeaker).value = $event : null)),
              options: _unref(audioOutputDevices),
              disabled: _unref(isAudioOutputTestRunning) || _unref(isRecording),
              class: "w-full"
            }, null, 8, ["modelValue", "options", "disabled"])),
        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('video-diagnostic.microphone')), 1),
        _createVNode(_component_SelectOption, {
          modelValue: _unref(selectedAudio),
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => (_isRef(selectedAudio) ? (selectedAudio).value = $event : null)),
            _unref(readAudioInput)
          ],
          options: _unref(audioInputDevices),
          disabled: _unref(isAudioOutputTestRunning) || _unref(isRecording),
          class: "w-full"
        }, null, 8, ["modelValue", "options", "disabled", "onUpdate:modelValue"]),
        _createElementVNode("div", _hoisted_13, [
          (_unref(isAudioOutputTestRunning))
            ? (_openBlock(), _createBlock(_component_SvgIcon, {
                key: 0,
                class: "mr-2",
                icon: 'speaker',
                "inherit-fill": true,
                height: "24"
              }))
            : (_openBlock(), _createBlock(_component_SvgIcon, {
                key: 1,
                class: "mr-2",
                icon: 'mic',
                "inherit-fill": true,
                height: "24"
              })),
          _hoisted_14
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('video-diagnostic.audio-sound-good')), 1),
        _createElementVNode("div", {
          class: _normalizeClass([{ 'opacity-30 pointer-events-none': __props.stage === _unref(Stage).RESULTS }, "flex"])
        }, [
          _createElementVNode("button", {
            class: "text-white border-2 rounded-md border-white bg-primary-color py-2 px-4",
            type: "button",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (nextStage(true)))
          }, _toDisplayString(_ctx.$t('video-diagnostic.test-pass')), 1),
          _createElementVNode("button", {
            class: "skip-button rounded-md py-2 px-4 ml-4",
            type: "button",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (nextStage(false)))
          }, _toDisplayString(_ctx.$t('video-diagnostic.test-fail')), 1)
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["id", "class"]))
}
}

})